'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutComponent = exports.rentalCheckoutComponent = {
    template: require('./rental-checkout.html'),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        sellerId: '<',
        wizardMenuSteps: '<',
        rentedProductsOrder: '<'
    },
    controllerAs: 'vm',
    controller: ["$state", "common", "gettextCatalog", "Analytics", function controller($state, common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.wizardActiveStepIndex = 0;
        vm.rentedProducts = [];
        vm.wizardFinished = wizardFinished;
        vm.wizardCanceled = wizardCanceled;
        vm.hasRelatedProducts = hasRelatedProducts;
        vm.deliveryInfoChanged = deliveryInfoChanged;
        vm.contactInfoChanged = contactInfoChanged;
        vm.onProductsRentedSucces = onProductsRentedSucces;
        vm.stepOneFormValidChange = stepOneFormValidChange;
        vm.stepOneFormValid = false;

        function init() {
            common.setTitle(gettextCatalog.getString('Uw huuraanvraag'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/rentalProduct/' + vm.rentalProduct, gettextCatalog.getString('Uw huuraanvraag'));
        }

        function wizardFinished() {
            $state.go('seller.home', {
                sellerId: $state.params.sellerId
            });
        }

        function wizardCanceled() {
            $state.go('seller.rentProductOverview', {
                sellerId: $state.params.sellerId
            });
        }

        function hasRelatedProducts() {
            return vm.rentalProduct.relatedRentalProducts.length > 0;
        }

        function deliveryInfoChanged($event) {
            vm.deliveryInfo = $event;
        }

        function contactInfoChanged($event) {
            vm.contactInfo = $event;
        }

        function onProductsRentedSucces($event) {
            vm.rentedProductsOrder = $event;
        }

        function stepOneFormValidChange($event) {
            vm.stepOneFormValid = $event.isFormValid;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/rental-checkout.js
// module id = 1003
// module chunks = 0